import { SkeletonText, SkeletonButton } from '@dev-spendesk/grapes';
import React from 'react';

import styles from './SchedulePaymentsBlockLoader.module.css';

export const SchedulePaymentsBlockLoader = () => {
  return (
    <div className={styles.SchedulePaymentsBlockLoader}>
      <SkeletonText size="xl" width="60%" className="mb-24" />
      <SkeletonText size="xxl" width="40%" className="mb-32" />
      <SkeletonText size="l" width="70%" className="mb-32" />
      <SkeletonButton width="100%" />
    </div>
  );
};
